<template>
  <div>
    <v-container fluid class="pa-0 staff-master-container">
      <div>
        <v-card class="main mx-auto">
          <v-card-title>
            <v-row justify="space-between">
              <v-col cols="4">
                <InputSearch height="44" v-model="search" />
              </v-col>
              <v-col cols="2" class="d-flex justify-end">
                <ENJIBtn
                  color="#6170EB"
                  height="44"
                  class="px-6"
                  @click="
                    editItem({
                      id: '',
                      name: '',
                      qr: '',
                      email: '',
                      company_id: ''
                    })
                  "
                >
                  {{ $t('master.create_new') }}
                </ENJIBtn>
              </v-col>
            </v-row>
          </v-card-title>
          <hr size="2" style="border-top: 1px solid #d0d0d0" />
          <v-data-table
            height="66vh"
            :page.sync="page"
            :headers="headers"
            :items="adminList"
            :search="search"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :custom-filter="customFilter"
            :no-results-text="$t('alert.not_found')"
            :items-per-page="itemsPerPage"
            :loading="loading"
            hide-default-footer
            fixed-header
            :loading-text="$t('alert.loading')"
            class="elevation-1"
            item-style="font-size: 16px"
          >
            <template #[`item.edit`]="{ item }">
              <v-icon class="mr-3" @click="editItem(item)"> mdi-pencil </v-icon>
            </template>
            <template #[`item.name`]="{ item }">
              {{ item.name }}
            </template>
            <template #[`item.email`]="{ item }">
              {{ item.email }}
            </template>
            <template #[`item.company`]="{ item }">
              {{ item.company.name }}
            </template>
          </v-data-table>
          <Pagination v-model="page" :length="pageCount" />
        </v-card>
      </div>
    </v-container>
    <!-- dialog -->
    <div v-if="dialog">
      <v-dialog
        persistent
        v-model="dialog"
        width="600px"
        height="100vh"
        :transition="dialogTransition"
        content-class="custom-dialog-content"
      >
        <AdminForm
          @closeDialog="onCloseDialog"
          @createStaff="onCreateStaff"
          @delete="deleteStaff"
          :adminData="adminData"
          :adminList="adminList"
        >
        </AdminForm>
      </v-dialog>
    </div>
  </div>
</template>
<style>
/*== custom container ==*/
.staff-master-container .v-sheet.v-card {
  border-radius: 0px 12px 12px 12px;
}
.staff-master-container .v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none;
}

/*== custom Table ==*/
.elevation-1.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: #5d6060;
  font: normal normal normal 16px/18px Noto Sans JP;
  font-size: 16px;
}
.elevation-1.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 16px;
  font: normal normal normal 16px/18px Noto Sans JP;
  color: #161a1a;
  min-height: 57px;
  height: 57px;
}

.elevation-1.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:nth-child(1),
.elevation-1.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:nth-child(1) {
  padding-left: 24px !important;
  padding-right: 0;
}
.elevation-1.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:nth-child(2),
.elevation-1.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:nth-child(2) {
  padding-left: 6px;
  padding-right: 16px;
}
</style>

<script>
import ENJIBtn from '@/components/buttons/ENJIBtn.vue'
import InputSearch from '@/components/inputs/InputSearch.vue'
import Pagination from '@/components/Pagination.vue'
import AdminForm from '@/components/AdminForm.vue'

export default {
  components: {
    ENJIBtn,
    InputSearch,
    Pagination,
    AdminForm,
  },
  computed: {
    APP_TITLE: {
      get: function () {
        return process.env.VUE_APP_TITLE
      },
    },
  },
  data() {
    return {
      status: -1,
      adminData: {},
      dialog: false,
      dialogTransition: 'fade-transition-right',
      adminList: [],
      search: '',
      sortBy: 'sortNo',
      sortDesc: false,
      headers: [
        {
          text: '',
          value: 'edit',
          align: 'left',
          width: '10',
          sortable: false,
        },
        {
          text: this.$t('master.staff_name'),
          value: 'name',
          align: 'left',
        },
        {
          text: this.$t('master.mail_address'),
          value: 'email',
          align: 'left',
        },
        {
          text: this.$t('master.company'),
          value: 'company',
          align: 'left',
        },
      ],
      editedIndex: -1,
      editedItem: {},
      loading: true,
      page: 1,
      itemsPerPage: 100,
    }
  },
  created() {
    this.isAuthenticated()
  },
  computed: {
    pageCount() {
      return Math.ceil(this.adminList.length / this.itemsPerPage)
    },
  },
  methods: {
    isAuthenticated() {
      this.$cognito
        .isAuthenticated()
        .then(() => {
          this.initialize()
        })
        .catch((_session) => {
          this.$router.replace('/manager/signin')
        })
    },
    initialize() {
      this.loading = false
      this.showLoading({ show: true })

      // 園児情報取得
      this.$cognito
        .isAuthenticated()
        .then(async (auth) => {
          this.$axiosM
            .post(
              '/user/admin/list',
              { created_by: "root" },
              {
                headers: {
                  Authorization: auth.idToken,
                },
              }
            )
            .then(({ data }) => {
              this.loading = false
              this.showLoading({ show: false })
              this.adminList = data
            })
            .catch((error) => {
              console.log(error)
              this.loading = false
              this.showLoading({ show: false })
              if (error.response.status === 500) {
                //redirect to page error 500
                return this.$router.replace('/500')
              }
              this.showSnack({
                text: this.$t('alert.error_get_data_failed'),
                color: 'error',
                timeout: 6000,
              })
            })
        })
        .catch((error) => {
          console.error(error)
          this.loading = false
          this.showLoading({ show: false })
          this.showSnack({
            text: this.$t('alert.login_again'),
            color: 'error',
            timeout: 6000,
          })
          return this.$router.replace('/manager/signin')
        })
    },
    editItem(item) {
      if (item.id) {
        this.editedIndex = this.adminList.indexOf(item.id)
      }
      this.adminData = Object.assign({}, item)
      this.dialog = true
    },
    customFilter(value, search, item) {
      const searchLowerCase = this.search.toLowerCase()
      return (
        !!search &&
        (item.name.toLowerCase().includes(searchLowerCase) ||
          item.email.toLowerCase().includes(searchLowerCase))
      )
    },
    onCloseDialog() {
      this.dialog = false
    },
    deleteStaff() {
      this.dialog = false
      this.initialize()
    },
    onCreateStaff(value) {
      this.loading = true
      this.showLoading({ show: true })
      if (value.id) {
        this.$cognito
          .isAuthenticated()
          .then(async (auth) => {
            this.$axiosM
              .post('/user/update', value, {
                headers: {
                  Authorization: auth.idToken,
                },
              })
              .then(() => {
                this.loading = false
                this.showLoading({ show: false })
                this.initialize()
              })
              .catch(() => {
                this.loading = false
                this.showLoading({ show: false })
                this.showSnack({
                  text: this.$t('alert.update_failed'),
                  color: 'error',
                  timeout: 6000,
                })
              })
              .finally(() => {
                this.showLoading({ show: false })
                this.dialog = false
              })
          })
          .catch((error) => {
            console.error(error)
            this.loading = false
            this.showLoading({ show: false })
            this.showSnack({
              text: this.$t('alert.login_again'),
              color: 'error',
              timeout: 6000,
            })
            this.$router.replace('/manager/signin')
          })
      } else {
        this.$cognito
          .isAuthenticated()
          .then((auth) => {
            this.$axiosM
              .post(
                '/user/register', value ,
                {
                  headers: {
                    Authorization: auth.idToken,
                  },
                }
              )
              .then(() => {
                this.loading = false
                this.showLoading({ show: false })
                this.initialize()
              })
              .catch(() => {
                this.loading = false
                this.showLoading({ show: false })
                this.showSnack({
                  text: this.$t('alert.regist_failed'),
                  color: 'error',
                  timeout: 6000,
                })
              })
              .finally(() => {
                this.showLoading({ show: false })
                this.dialog = false
              })
          })
          .catch((error) => {
            console.error(error)
            this.loading = false
            this.showLoading({ show: false })
            this.showSnack({
              text: this.$t('alert.login_again'),
              color: 'error',
              timeout: 6000,
            })
            this.$router.replace('/manager/signin')
          })
      }
    },
  },
}
</script>
